<template>
  <v-app>
    <div v-if="environnement != 'production' && initFinished" class="ribbon">
      <a href="#">{{ environnement }}</a>
    </div>

    <BaseLoading :isVisible="loading.display" :message="loading.message" />

    <BaseHeader
      v-if="initFinished"
      :isSmartphoneMenu.sync="isSmartphoneMenu"
      :displayMenu.sync="displayMenu"
    />

    <BaseMenu
      v-if="initFinished"
      :isSmartphoneMenu="isSmartphoneMenu"
      :displayMenu.sync="displayMenu"
      :isMini="isMenuMinimal"
    />

    <v-main v-if="initFinished">
      <v-container fluid>
        <router-view transition="fade-transition"></router-view>
      </v-container>
    </v-main>
    <BaseSwitchTheme class="switch-theme" />
  </v-app>
</template>

<script>
import BaseLoading from "@/components/base/BaseLoading";
import BaseMenu from "@/components/base/BaseMenu";
import BaseHeader from "@/components/base/BaseHeader";
import BaseSwitchTheme from "@/components/base/BaseSwitchTheme";
import { mapState } from "vuex";
import axios from "axios";

export default {
  name: "App",
  components: {
    BaseLoading,
    BaseMenu,
    BaseHeader,
    BaseSwitchTheme
  },
  data() {
    return {
      // Variables d'ajustements graphiques
      // - menu affiché ou non
      displayMenu: null,
      // - menu en mode smartphone ou non
      isSmartphoneMenu: this.$isMobile(),
      // - affiche ou non le menu en mode minimal
      isMenuMinimal: process.env.VUE_APP_MENU_MINIMAL === "true" ? true : false,
      // -pour affichier on non le bandeau spécifiant que l'instance de l'application n'est pas en production
      environnement: process.env.NODE_ENV
    };
  },
  computed: {
    ...mapState(["user", "loading", "isAuthenticated", "dossier"]),

    initFinished() {
      // Si personne authentifiée, init terminée
      if (this.isAuthenticated) {
        this.$store.commit("setEcranChargement", false);
        return true;
      }

      // Si personne non authentifiée et (route non initialisée ou route demandant authentification), init non terminée
      if (
        this.$lodash.isEmpty(this.$route.meta) ||
        this.$route.meta.access.type === "authenticated"
      ) {
        return false;
      }

      // Si personne non authentifiée, et route publique, init terminée
      this.$store.commit("setEcranChargement", false);
      return true;
    }
  },
  watch: {
    "$vuetify.theme.dark"() {
      localStorage.darkTheme = this.$vuetify.theme.dark;
    }
  },
  created: function() {
    // interception globale des appels API avec code 401 ("non autorisé") en retour
    var vm = this;
    axios.interceptors.response.use(
      function(response) {
        return response;
      },
      function(error) {
        if (401 === error.response.status) {
          vm.$store.commit(
            "setMessageEcranChargement",
            "Vous n'êtes plus connecté(e), tentative de reconnexion en cours..."
          );
          vm.$store.commit("setEcranChargement", true);

          setTimeout(
            () =>
              (window.location.href =
                process.env.VUE_APP_BACKEND_API_URL +
                process.env.VUE_APP_URL_LOGIN),
            3000
          );
        } else {
          return Promise.reject(error);
        }
      }
    );
  },
  mounted() {
    if (localStorage.darkTheme === "true") {
      this.$vuetify.theme.dark = true;
    }
  }
};
</script>

<style>
html {
  overflow-y: auto;
}

.ribbon {
  background-color: rgba(170, 0, 0, 1);
  left: -3.5em;
  transform: rotate(-45deg);
  overflow: hidden;
  position: fixed;
  top: 30px;
  white-space: nowrap;
  width: 15em;
  z-index: 9999;
  pointer-events: none;
  opacity: 0.75;
  text-align: center;
  padding: 10px;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.8em;
}

.v-application.theme--light {
  background-color: #ededed !important;
}

.v-application.theme--dark {
  background-color: #121212 !important;
}

.v-application .ribbon a {
  color: #fff;
  text-decoration: none;
}

.title-divider {
  margin: 1rem -1rem;
  max-width: initial;
}

.switch-theme {
  position: absolute !important;
  right: 15px;
  bottom: 15px;
}
</style>
